export default __webpack_public_path__ + "static/media/minus.6e992e89.svg";